<template lang="html">
    <div class="full-price" v-if="$props.payers && $props.payerId">
        <div
            v-for="(payer, i) in payers"
            v-bind:class="{'even': (i%2 == 0), 'odd': (i%2 != 0)}"
            v-if="resPayerPrice(payer.id) || parseInt(payer.id) === parseInt($props.payerId)"
            class="payer-price-item"
        >
            <div class="full-price__item-title">
                <b>{{ payer.name }}</b>
            </div>

            <template v-if="parseInt(payer.id) === parseInt($props.payerId)">
                <div class="full-price__item">
                    <div class="full-price__item-title">{{ ((parseInt(deal.first_freight.doom) === 1) ? 'Цена перевозки (с учётом обрешётки)' : 'Цена перевозки') }}</div>
                    <div class="full-price__item-edit" v-if="canEditPrice">
                        <md-button
                            v-if="parseInt(deal.first_freight.full_price.manual) === 1"
                            class="md-icon-button md-dense close small fill-price__item-edit-btn"
                            @click="manualDeleteOpen('default', 'Цена перевозки')"
                        >
                            <i class="fas fa-trash"></i>
                            <md-tooltip md-direction="top" md-delay="500">Установить расчетную цену</md-tooltip>
                        </md-button>
                        <md-button
                            class="md-icon-button md-dense close small fill-price__item-edit-btn"
                            @click="manualEditOpen('default', deal.first_freight.full_price.default, 'Цена перевозки')"
                        >
                            <i class="fas fa-pen"></i>
                            <md-tooltip md-direction="top" md-delay="500">Изменить</md-tooltip>
                        </md-button>
                    </div>
                    <div class="full-price__item-value">{{formatPrice(deal.first_freight.full_price.default) + ' руб.'}}</div>
                </div>

                <div class="full-price__item" v-if="deal.first_freight.full_price.markup > 0">
                    <div class="full-price__item-title">Наценка</div>
                    <div class="full-price__item-value"> {{formatPrice(deal.first_freight.full_price.markup) + ' руб.'}}</div>
                </div>
                <div class="full-price__item" v-if="deal.first_freight.full_price.discount > 0">
                    <div class="full-price__item-title">Скидка</div>
                    <div class="full-price__item-value">{{formatPrice(deal.first_freight.full_price.discount) + ' руб.'}}</div>
                </div>

                <div class="full-price__item">
                    <div class="full-price__item-title">
                        <b>Дополнительные услуги</b>
                    </div>
                </div>

                <template v-if="deal.first_freight.full_price.additional_services && Object.values(deal.first_freight.full_price.additional_services)">
                    <div
                        class="full-price__item"
                        v-for="item in Object.values(deal.first_freight.full_price.additional_services)" v-if="item.value > 0"
                    >
                        <div class="full-price__item-title">{{item.label}}</div>
                        <div class="full-price__item-value"> {{formatPrice(item.value) + ' руб.'}}</div>
                    </div>
                </template>
            </template>

            <template
                v-if="deal.first_freight.full_price.additional && Object.values(deal.first_freight.full_price.additional)"
            >
                <div class="full-price__item"
                    v-for="[code, item] in Object.entries(deal.first_freight.full_price.additional)"
                    v-if="(item.value > 0 || (item.value <= 0 && parseInt(item.manual) === 1)) && (parseInt(item.payer_id) === parseInt(payer.id) || !item.payer_id)"
                >
                    <div class="full-price__item-title">{{item.label}}</div>
                    <div class="full-price__item-edit" v-if="canEditPrice">
                        <md-button
                            v-if="parseInt(item.manual) === 1"
                            class="md-icon-button md-dense close small fill-price__item-edit-btn"
                            @click="manualDeleteOpen(code, item.label)"
                        >
                            <i class="fas fa-trash"></i>
                            <md-tooltip md-direction="top" md-delay="500">Установить расчетную цену</md-tooltip>
                        </md-button>
                        <md-button
                            class="md-icon-button md-dense close small fill-price__item-edit-btn"
                            @click="manualEditOpen(code, item.value, item.label)"
                        >
                            <i class="fas fa-pen"></i>
                            <md-tooltip md-direction="top" md-delay="500">Изменить</md-tooltip>
                        </md-button>
                    </div>
                    <div class="full-price__item-value"> {{formatPrice(item.value) + ' руб.'}}</div>
                </div>
            </template>

            <div class="full-price__item" v-if="resPayerPrice(payer.id)">
                <div class="full-price__item-title">НДС</div>
                <div class="full-price__item-value"> {{formatPrice( resPayerPrice(payer.id)['nds'] ) + ' руб.'}}</div>
            </div>

            <div class="full-price__item" v-if="resPayerPrice(payer.id)">
                <div class="full-price__item-title">Цена без НДС</div>
                <div class="full-price__item-value">{{formatPrice( resPayerPrice(payer.id)['without_nds'] ) + ' руб.'}}</div>
            </div>

            <div class="full-price__item result" v-if="resPayerPrice(payer.id)">
                <div class="full-price__item-title">Итого</div>
                <div class="full-price__item-value">{{formatPrice( resPayerPrice(payer.id)['result'] ) + ' руб.'}}</div>
            </div>
        </div>
          
        <div class="payer-price-item">
            <div class="full-price__item-title">
                <b>Итоговая цена по заявке</b>
            </div>
            <div class="full-price__item">
                <div class="full-price__item-title">НДС</div>
                <div class="full-price__item-value"> {{formatPrice(deal.first_freight.full_price.nds) + ' руб.'}}</div>
            </div>
            <div class="full-price__item">
                <div class="full-price__item-title">Цена без НДС</div>
                <div class="full-price__item-value"> {{formatPrice(deal.first_freight.full_price.without_nds) + ' руб.'}}</div>
            </div>
            <div class="full-price__item result">
                <div class="full-price__item-title">Итого</div>
                <div class="full-price__item-value"> {{formatPrice(deal.first_freight.full_price.result) + ' руб.'}}</div>
            </div>
        </div>

        <div class="payer-price-item">
            <hr/>
            <div class="full-price__item-title storate">
                <b>Хранение груза</b>
                <md-button
                    v-bind:disabled="blocked" v-on:click="recalc"
                    class="md-icon-button md-dense close small storage-btn recalc"
                >
                    <i class="fas fa-sync-alt"></i>
                    <md-tooltip md-direction="top" md-delay="500">Обновить срок, стоимость хранения и связанные документы</md-tooltip>
                </md-button>
            </div>

            <div v-if="$props.storage && $props.storage.list.length">
                <div class="full-price__item" v-for="store in $props.storage.list">
                    <div class="full-price__item-title">{{ store.stock.name }}</div>

                    <div class="full-price__item-value" v-if="store.storage_error">
                        <span class="error">{{ store.storage_error }}</span>
                    </div>
                    <div v-else class="full-price__item-value">
                        <span v-if="store.to_today" class="error">✸</span>
                        <b>{{ store.storage_time_display }}</b>
                        <span>{{ ' (' + moment(store.from_date).tz($root.userTimezone).format('DD.MM.YYYY') + ' - ' + moment(store.to_date).tz($root.userTimezone).format('DD.MM.YYYY') + ')' }}</span>
                    </div>
                    <md-tooltip v-if="store.to_today" md-direction="top" md-delay="500">
                        Отстутствует трекинг выдачи получателю. Расчёт до текущей даты на складе назначения.
                    </md-tooltip>
                </div>

                <div class="full-price__item result" v-if="$props.storage && $props.storage.total && $props.storage.total.display">
                    <div class="full-price__item-title">Итого</div>
                    <div class="full-price__item-value">{{ $props.storage.total.display }}</div>
                </div>

                <div class="full-price__item result" v-if="$props.freight && $props.freight.storage_time_service">
                    <div class="full-price__item-title">Сверхнормативное хранение (с учётом нерабочих дней)</div>
                    <div class="full-price__item-value">{{ `${$props.freight.storage_time_service} дн.` }}</div>
                </div>
            </div>
        </div>
        
        <ZDialog v-bind:active="manualEditForm.active" @close="manualEditCancel">
            <template slot="title">
                {{ `Изменение стоимости услуги "${manualEditForm.label}"` }}
            </template>
            <template slot="default">
                <z-input
                    v-model="manualEditForm.value" v-bind:error="manualEditForm.error"
                    label="Укажите стоимость" type="number" placeholder="000.00"
                ></z-input>
            </template>
            <template slot="actions">
                <ZButton @click="manualEditCancel" accent>Отмена</ZButton>
                <ZButton @click="manualEditSave"   primary>Сохранить</ZButton>
            </template>
        </ZDialog>

        <ZDialog v-bind:active="manualDeleteForm.active" @close="manualDeleteCancel">
            <template slot="title">
                {{ `Установить расчетную стоимость для услуги "${manualDeleteForm.label}"` }}
            </template>
            <template slot="actions">
                <ZButton @click="manualDeleteCancel" accent>Отмена</ZButton>
                <ZButton @click="manualDeleteSave"   primary>Сохранить</ZButton>
            </template>
        </ZDialog>
        
    </div>
</template>
<script>
    import ZInput  from '@/components/ZInput';
    import ZDialog from '@/components/ZDialog.vue'
    import ZButton from '@/components/ZButton.vue'
    export default {
        name: 'price-list',
        props: {
            deal: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            freight: {
                type: Object,
                default: () => {
                    return {};
                }
            },            
            payerId: {
                type: Number,
                default: null
            },
            payers: {
                type: Array,
                default: []
            },
            storage: {
                type: Object,
                default: () => {
                    return {
                        list: [],
                        total: {
                            value: 0,
                            display: null
                        }
                    }
                }
            },
            blocked: {
                type: Boolean,
                default: false
            },            
        },
        components: { ZInput, ZDialog, ZButton },
        data() {
            return {
                manualEditForm: {
                    code:  '',
                    label: '',
                    error: '',
                    value: 0,
                    active:  false,
                    loading: false
                },
                manualDeleteForm: {
                    code:  '',
                    label: '',
                    active:  false,
                    loading: false
                },
            }
        },
        computed: {
            canEditPrice() {
                return (
                    this.$props.freight &&
                    this.$props.freight.id &&
                    !this.$props.blocked
                )
            }
        },
        watch: {},
        methods: {
            formatPrice(price) {
                return parseFloat(price).toLocaleString('ru-RU', {style: 'currency', currency: 'RUB', minimumFractionDigits: 2}).replace(/,+/g, '.').replace(/\s+/g, ',').replace(',₽', '');
            },
            resPayerPrice(id) {
                if (
                    !this.deal || !this.deal.first_freight || !this.deal.first_freight.full_price ||
                    !this.deal.first_freight.full_price.payers || !this.deal.first_freight.full_price.payers[id]
                ) return null;

                return this.deal.first_freight.full_price.payers[id];
            },
            recalc() {
                if (this.$props.blocked) return;
                this.$emit('recalc')
            },
            manualDeleteOpen(code, label) {
                this.manualDeleteForm.label  = label
                this.manualDeleteForm.code   = code
                this.manualDeleteForm.active = true
            },
            manualDeleteSave() {
                if (this.manualDeleteForm.loading || !this.manualDeleteForm.code) return
                this.$store.dispatch('deals/unsetManualPrice', {
                    code: this.manualDeleteForm.code,
                    freight_id: this.$props.freight.id,
                }).then((deal) => {
                    if (!deal) return
                    this.$emit('update', deal)
                    this.manualDeleteCancel()
                }).finally(() => this.manualDeleteForm.loading = false)
            },
            manualDeleteCancel() {
                this.manualDeleteForm = Object.assign({}, {
                    code:  '',
                    label: '',
                    active:  false,
                    loading: false
                })
            },

            manualEditOpen(code, value, label) {
                this.manualEditForm.error = ''
                this.manualEditForm.label = label
                this.manualEditForm.value = value
                this.manualEditForm.code  = code
                this.manualEditForm.active = true
            },
            manualEditCancel() {
                this.manualEditForm = Object.assign({}, {
                    code:  '',
                    label: '',
                    error: '',
                    value: 0,
                    active:  false,
                    loading: false
                })
            },
            manualEditSave() {
                if (this.manualEditForm.loading) return
                this.manualEditForm.error = ''
                if (
                    !this.$props.freight ||
                    !this.$props.freight.id ||
                    !this.manualEditForm.code  ||
                    !this.manualEditForm.value ||
                    parseFloat(this.manualEditForm.value) < 0
                ) {
                    this.manualEditForm.error = 'Проверьте корректность указания цены и создания груза'
                    return;
                }

                this.manualEditForm.loading = true
                this.$store.dispatch('deals/setManualPrice', {
                    label: this.manualEditForm.label,
                    value: this.manualEditForm.value,
                    code:  this.manualEditForm.code,
                    freight_id: this.$props.freight.id,
                }).then((deal) => {
                    if (!deal) return
                    this.$emit('update', deal)
                    this.manualEditCancel()
                }).finally(() => this.manualEditForm.loading = false)
            }
        },
        created() {},
    }
</script>
<style lang="sass">
    .full-price
        .full-price__item-title.storage
            display: flex
            align-items: center
            justify-content: flex-start
        .full-price__item-value
            margin: 0 0 0 5px
            .info-icon
                color: red
                margin: 0 0 0 5px
        .full-price__item-edit
            margin: auto 0 auto auto

        .fill-price__item-edit-btn
</style>


// WEBPACK FOOTER //
// PriceList.vue?6b832a4e